export default __webpack_public_path__ + "static/media/downloadOnMac.1d39e8da.svg";